import {Component} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {ContentVm} from 'src/app/view-model/content/content.vm';

@Component({
  selector: 'app-covid',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent {
  name: string;
  content: string;

  constructor(private location: Location,
              private vm: ContentVm,
              private activateRoute: ActivatedRoute) {
    this.activateRoute.params.subscribe(params => {
      if (params.tag) { this.getContent(params.tag); }
    });
  }

  getContent(tag: string) {
    this.vm.getContent(tag).subscribe((res: any) => {
      this.name = res.name;
      this.content = res.content;
    });
  }

  goBack() {
    this.location.back();
  }
}
